import React from 'react';
import PropTypes from 'prop-types';

const Step = ({ isCurrent }) => {

  const steps = [
    { stepNumber: 1, stepText: '申込み内容確認', multiplelines: false },
    { stepNumber: 2, stepText: '会員認証', multiplelines: false },
    { stepNumber: 3, stepText: 'お客様情報入力', multiplelines: false },
    {
      stepNumber: 4,
      stepText: '最終確認',
      multiplelines: false
    },
    { stepNumber: 5, stepText: '予約完了', multiplelines: false }
  ];

  const stepsSp = [
    {
      stepNumber: 1,
      stepText: '申込み内容<br />確認',
      multiplelines: true
    },
    { stepNumber: 2, stepText: '会員認証', multiplelines: false },
    {
      stepNumber: 3,
      stepText: 'お客様情報<br />入力',
      multiplelines: true
    },
    {
      stepNumber: 4,
      stepText: '最終確認',
      multiplelines: false
    },
    { stepNumber: 5, stepText: '予約完了', multiplelines: false }
  ];

  return (
    <div className="steps">
      <div className="stepLine"></div>
      <div className="stepItems isPC">
        {steps.map((step) => {
          const { stepNumber, multiplelines, stepText } = step;
          const current = stepNumber === isCurrent;

          return (
            <div className="stepItem" key={stepNumber}>
              {current ? (
                <div className="stepSymbol isCurrent">
                  <img src="/dpp/img/icons/check.svg" alt="" />
                </div>
              ) : (
                <div className="stepSymbol">{stepNumber}</div>
              )}
              <div
                className={`stepText ${multiplelines ? 'multiplelines' : ''} ${current ? 'currentText' : ''}`}
                dangerouslySetInnerHTML={{
                  __html: stepText
                }}
              />
            </div>
          );
        })}
      </div>
      <div className="stepItems isSP">
        {stepsSp.map((step) => {
          const { stepNumber, multiplelines, stepText } = step;
          const current = stepNumber === isCurrent;

          return (
            <div className="stepItem" key={stepNumber}>
              {current ? (
                <div className="stepSymbol isCurrent">
                  <img src="/dpp/img/icons/check.svg" alt="" />
                </div>
              ) : (
                <div className="stepSymbol">{stepNumber}</div>
              )}
              <div
                className={`stepText ${multiplelines ? 'multiplelines' : ''} ${current ? 'currentText' : ''}`}
                dangerouslySetInnerHTML={{
                  __html: stepText
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

Step.defaultProps = {
  isCurrent: 1,
};

Step.propTypes = {
  isCurrent: PropTypes.number.isRequired,
};

export default Step;
